<section class="has-padding-block-1 animated fadeIn" >
  <div class="row" style="column-count: 4">
    <div class="col-sm-7">
      <h2 class="section-title">Building a Local Food System</h2>
      <p><strong>We’re not just farmers’ customers, we’re their partners.</strong></p>
      <p>The origins of Philly Foodworks can be traced back to a phone call Dylan Baird (Philly Foodworks’ co-founder/CEO) had with Reuben Riehl in 2012. The two hit it off, discussing everything from philosophy to the struggles of running a small farm.</p>
    </div>
    <div class="col-sm-5">
      <img src="../../../assets/images/landing/building-a-local-food-system/building-a-local-food-system-1.webp"  class="img-side is-aspect-3-2" alt="How we support farmers image">
    </div>
    <div class="col-12">
      <p>Dylan, an urban farmer in West Philadelphia at the time, struggled to yield enough crops to meet demand. Reuben, an Amish farmer in Chester County, produced plenty of fruits and vegetables but could not find enough customers and lacked the staff, time, and resources to travel to Philly’s open-air markets.</p>
      <p>Soon after his conversation with Reuben, Dylan and his business partners founded Philly Foodworks in an effort to help farmers in similar situations get their sustainably grown produce in the Philly-area consumer market. Since then, Philly Foodworks has become a leader in our local food system, focused not only on selling the delicious fruits, veggies, meats, cheeses, and other food products our region has to offer, but also on building partnerships with growers and producers to help them thrive for years to come.</p>
    </div>
  </div>
  <hr class="is-thick">
  <div>
    <h2 class="section-title">Fair prices & efficient transportation</h2>
    <p>Unlike many traditional distributors that demand exclusivity and leverage competition to get the
      lowest-possible prices, we keep farmers’ well-being at the center of our business model. We allow our
      growers and producers to sell to whomever they want and encourage them to do what is best for their
      businesses.</p>
  </div>

  <div class="row">
    <div class="col-sm-5"><img src="../../../assets/images/landing/building-a-local-food-system/building-a-local-food-system-2.webp"  class="img-side is-height-3"/></div>
    <div class="col-sm-7">
      <div class="banner-title-wrap is-right mb-5">
        <div class="banner-title is-full-width is-primary">
          <p>We discuss pricing with farmers at the beginning of the year and do not change what we pay for
            product unless both sides agree.</p>
        </div>
      </div>
      <p>When our company was newly formed, Philly Foodworks and Riehl Family Farms worked together to create the
        Honey Brook Harvest Collective, an aggregation hub based on the Riehl Family Farm, which handles the
        cleaning, packaging, and distribution of fresh-grown produce from 12 farms in the Honey Brook area. By
        consolidating these tasks that require a lot of overhead (coolers, trucks, packing equipment, etc.), the
        Honey Brook Harvest Collective has opened up opportunities for small farmers to sell their goods in and
        around Philadelphia.</p>
    </div>
  </div>

  <p>We have since established a network of aggregation hubs where multiple farmers in certain areas can
    deliver products to be transported in consolidated deliveries to our warehouse in Philadelphia. And we
    cover the cost of trucking! This not only reduces the carbon footprint and allows smaller farmers to
    access the city market, but it also allows farmers to keep more of their profits to invest back in their
    business.</p>
 <hr class="is-thick">
  <div>
    <h2 class="section-title">Crop planning and collaboration</h2>
    <p>In 2018, we launched a project aimed at increasing the diversity of our products and locking in
      seasonal orders far in advance. The result was a giant spreadsheet detailing the specific crops each of
      our farmers grow, roughly how much they will be planting for upcoming seasons, and the approximate time
      they plan to harvest. When he noted overlapping crops among different farms, our produce buyer, Loren,
      collaborated with the farmers to choose different varieties or later planting times so Philly Foodworks
      won’t have to turn away any of our farmers’ crops due to excess supply, and so excess crops won’t go to
      waste in the fields due to lack of demand.</p>
    <p>As a bonus, this also means that we’ll have an even wider range of produce in the coming seasons, as
      well as longer availability of items due to staggered plantings among different farms. For the farmers,
      it means that they have a guaranteed market for their products and the support (both financial and
      strategic) to try new varieties—like Black Nebula carrots and Sichuan Red Beauty radishes, for instance.
      We are currently working with 10 different farmers and farmer collectives, and we’re in talks with
      others who will hopefully join Philly Foodworks soon.</p>
  </div>

  <div class="banner-title-wrap is-center">
    <div class="banner-title is-multi-line is-primary">
      <p>Next up, we’re planning to expand this system to nearby farmers in New Jersey!</p>
    </div>
  </div>

  <div class="has-padding-block-2">
    <img src="../../../assets/images/landing/building-a-local-food-system/building-a-local-food-system-3.webp" class="img-fluid" alt="banner image"/>
  </div>
  <hr class="is-thick">
  <div>
    <h2 class="section-title">The Impact of CSA Deposits</h2>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">grass</span>
      <div class="list-content">
        <h3 class="list-title">Greenhouses</h3>
        <p>Philly Foodworks has financed three greenhouses. One of those was for one of our longtime farming
          partners, John Glick, which enabled him to extend his season for raspberries and tomatoes and supply
          the Philly Foodworks market with more fresh produce throughout the year. We just secured funding for
          a second greenhouse at John’s which will be fully heated, allowing him to grow in the ground during
          the dead of winter, and enabling him to expand his offerings even more—including some crops
          exclusively for PFW!</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">agriculture</span>
      <div class="list-content">
        <h3 class="list-title">A truck</h3>
        <p>Used to aggregate food in Honey Brook and bring produce down to Philadelphia.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">thermometer_loss</span>
      <div class="list-content">
        <h3 class="list-title">A cooler</h3>
        <p>Used to store produce before it is sent to market.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">construction</span>
      <div class="list-content">
        <h3 class="list-title">Washing equipment</h3>
        <p>Items like an industrial salad spinner and barrel washers for cleaning root crops make the
          labor-intensive practice of washing and packing produce incredibly efficient.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">school</span>
      <div class="list-content">
        <h3 class="list-title">Farmer education</h3>
        <p>PFW members financed a trip for six Amish farmers to travel to Harvest Valley Farms outside of
          Pittsburgh and meet with head farmer Dave King, who specializes in season extension. Dave provided
          valuable information for the farmers to bring back to their own farms to help them grow delicious
          produce for PFW members.</p>
      </div>
    </div>
    <div class="ul-icon-list">
      <span class="list-icon material-symbols-outlined">psychiatry</span>
      <div class="list-content">
        <h3 class="list-title">Garlic seed</h3>
        <p>We financed one acre of garlic at Taproot Farm. Taproot harvested and sold half an acre and kept
          the other half to build their own seed bank so the crop can begin to adapt to the microclimate of
          their farm and develop resilience particular to their region. This also allowed them to save money
          on next year's garlic seed.</p>
      </div>
    </div>
  </div>

</section>
